export const RETAINERS_ARCHIVE_ROUTE_PATH = 'archive';
export const RETAINERS_ARCHIVE_URL = '/retainers/archive';

/** Where a restored project is opened: its terms page. */
export const getRetainerTermsUrl = (id: number | string): string => `/retainers/terms/${id}`;
